import Animated from "react-native-reanimated";
import { useScrollContext } from "@navigations/utils/ScrollContext";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { css } from "styled-components/native";
import { LayoutContainerProps } from "./types";
import { DefaultTheme } from "styled-components/native";

const LayoutContainer = ({
  children,
  showAsPopover,
  backgroundColor = "core-02",
  allowFlex = true,
}: LayoutContainerProps) => {
  const [_, __, style] = useScrollContext();
  const theme = useTheme();
  const safeStyle = style || {};

  if (theme.isLargeScreen)
    return (
      <DesktopView backgroundColor={backgroundColor}>{children}</DesktopView>
    );

  return (
    <StyledView
      style={[showAsPopover ? {} : safeStyle]}
      isLargeScreen={theme.isLargeScreen}
      allowFlex={allowFlex}
    >
      {children}
    </StyledView>
  );
};

const StyledView = styled(Animated.View)<{
  isLargeScreen?: boolean;
  allowFlex?: boolean;
}>`
  background-color: ${({
    theme,
    isLargeScreen,
  }: {
    theme: DefaultTheme;
    isLargeScreen: boolean;
  }) => (isLargeScreen ? theme["core-01"] : theme["core-02"])};
  ${({ theme, allowFlex }: { theme: DefaultTheme; allowFlex: boolean }) =>
    allowFlex &&
    css`
      flex: ${theme.isMobile ? 1 : "auto"};
    `}
  max-height: 100%;
`;

const DesktopView = styled.View<{
  backgroundColor: string;
}>`
  flex: 1;
  flex-basis: auto;
  ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor &&
    css`
      background-color: ${({ theme }: { theme: DefaultTheme }) =>
        theme[backgroundColor as keyof DefaultTheme] as string};
    `}
`;

export default LayoutContainer;
